import { render, staticRenderFns } from "./PaseListaDiario.vue?vue&type=template&id=58bc66cb&scoped=true"
import script from "./PaseListaDiario.vue?vue&type=script&lang=js"
export * from "./PaseListaDiario.vue?vue&type=script&lang=js"
import style0 from "./PaseListaDiario.vue?vue&type=style&index=0&id=58bc66cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc66cb",
  null
  
)

export default component.exports